/*
 * Part of the RubinRed CMS.
 * @author    Paolo Pontarollo <pontarollo@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.it
 */

export default class Currencies {
  constructor() {
    this.current = 'EUR';
    this.supported = {EUR: 'euro'};
  }

  static prepare(value) {
    if (!value) {
      return 0;
    }

    return value / 100;
  }

  toHuman(value) {
    // TODO: check if Intl is defined
    return Intl.NumberFormat(this.current, {
      style: 'currency',
      currency: this.current,
    }).format(Currencies.prepare(value));
  }

  setCurrent(currency) {
    this.current = currency;

    return this;
  }

  getCurrent() {
    return this.current;
  }

  setSupported(supported) {
    this.supported = supported;

    return this;
  }

  getSupported() {
    return this.supported;
  }
}

window.App.Utils.Currencies = new Currencies();



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/currencies/assets/js/Currencies.js